import { connect, FieldArray } from 'formik'
import { Button } from '@/ui'
import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { Plus } from '@app/images'
import { InjuredItem } from '@features/accidents/steps/accidentReport/InjuredItem'

export const Victim = connect(({ formik: { values } }) => {
	const { t } = useTranslation()

	return (
		<>
			<FieldArray name={'injureds'}>
				{({ push, remove }) => {
					return (
						<>
							{values.injureds?.map((item, index) => {
								return <InjuredItem key={index} item={item} index={index} remove={remove} />
							})}

							<section>
								<Button
									textColor="green"
									borderColor="green"
									transparent
									border
									type="button"
									icon={Plus}
									onClick={() => push({ isResident: true })}
								>
									{t('accidentsPage.register.addVictim')}
								</Button>
							</section>
						</>
					)
				}}
			</FieldArray>
		</>
	)
})
